import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '01',
    title: 'Identifica',
    description: 'Usa el Semáforo Social para mapear el círculo de tu hijo en menos de 24 horas.'
  }, {
    number: '02',
    title: 'Equipa',
    description: 'Practica los guiones anti-presión para que tu hijo sepa defenderse solo.'
  }, {
    number: '03',
    title: 'Conecta',
    description: 'Implementa el Protocolo de Puertas Abiertas para recuperar el control de tu hogar.'
  }];
  return <section ref={ref} className="w-full bg-darker-navy py-16 md:py-20 px-6" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          <h2 className="text-4xl md:text-5xl font-oswald text-gold mb-12 text-center" data-id="element-44">
            Cómo Funciona
          </h2>

          <div className="space-y-8" data-id="element-45">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -30
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex gap-6 items-start bg-dark-navy p-8 rounded-lg border-l-4 border-cyan" data-id="element-46">
                <div className="text-6xl font-oswald text-cyan/30 leading-none" data-id="element-47">
                  {step.number}
                </div>
                <div className="flex-1" data-id="element-48">
                  <h3 className="text-2xl font-oswald text-gold mb-3" data-id="element-49">
                    {step.title}
                  </h3>
                  <p className="text-lg text-gray-300 leading-relaxed" data-id="element-50">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}